import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
    TfiServer,
    TfiFiles,
    TfiEmail,
    TfiDirectionAlt,
    TfiPanel,
    TfiSettings,
    TfiImport,
    TfiBarChart
} from 'react-icons/tfi';
import cpanelImage from '../../assets/img/cpanelui.png';
import cpanelFull from '../../assets/img/cpanel-full.png';
import './cpanelWidget.scss';

function CpanelWidget({ dataType }) {
    const { t } = useTranslation();
    const cpanelData = [
        {
            title: t('web-hosting-page.cpanel-column.property-1'),
            image: <TfiServer />
        },
        {
            title: t('web-hosting-page.cpanel-column.property-2'),
            image: <TfiFiles />
        },
        {
            title: t('web-hosting-page.cpanel-column.property-3'),
            image: <TfiEmail />
        },
        {
            title: t('web-hosting-page.cpanel-column.property-4'),
            image: <TfiDirectionAlt />
        },
        {
            title: t('web-hosting-page.cpanel-column.property-5'),
            image: <TfiPanel />
        },
        {
            title: t('web-hosting-page.cpanel-column.property-6'),
            image: <TfiSettings />
        },
        {
            title: t('web-hosting-page.cpanel-column.property-7'),
            image: <TfiImport />
        },
        {
            title: t('web-hosting-page.cpanel-column.property-8'),
            image: <TfiBarChart />
        }
    ];
    const renderCpanelItem = (cpanel, index) => (
        <Col md={6} key={`${cpanel.title}-${index}`}>
            <div className="single-cpanel">
                <div className="cpanel-image-wrapper">{cpanel.image}</div>
                <h3 className="cpanel-title">{cpanel.title}</h3>
            </div>
        </Col>
    );

    return (
        <div className="cpanel-columns-wrapper">
            <Row>
                {dataType === 'reseller' ? (
                    <Col>
                        <img className="cpanel-main-image" src={cpanelFull} alt="Cpanel" />
                    </Col>
                ) : (
                    <>
                        <Col lg={6}>
                            <img className="cpanel-main-image" src={cpanelImage} alt="Cpanel" />
                        </Col>
                        <Col lg={6}>
                            <Row>{cpanelData.map(renderCpanelItem)}</Row>
                        </Col>
                    </>
                )}
            </Row>
        </div>
    );
}

CpanelWidget.propTypes = {
    dataType: PropTypes.string
};

CpanelWidget.defaultProps = {
    dataType: 'web'
};

export default CpanelWidget;
